import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import Routing from "./Components/Routing/index.jsx";
import { useMainContext } from "./Context";
import { authRouter, userRouter } from "./Router";
import { caching } from "./Utils/functions";

const App = () => {
  const { isLogin } = useMainContext();
  useEffect(() => {
    caching();
  }, []);

  return (
    <>
      <Routing
        routes={[...userRouter, ...authRouter]}
        redirect={isLogin() ? "/dashboard" : "login"}
      />

      {/* <Navigate to={isLogin() ? "/dashboard" : "/login"} path="*" replace />; */}
    </>
  );
};

export default App;
